import * as moment from 'moment';

export enum StatusOfBusinessPartner {
    None,
    Saving,
    ErrorTryAgain,
    ErrorCustomerAlreadyCreated,
    Success,
}

export interface IBusinessPartnerRequest {
    showModal: boolean,
    status: StatusOfBusinessPartner,
    isNew: boolean,
    promoted: string,

    shippingAddress1: string,
    shippingAddress2: string,
    shippingCity: string,
    shippingState: string,
    shippingZipcode: string,

    licenceNumber: string,
    licenceExp: {
        date: moment.Moment,
        label: string
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/businessPartner.ts